import { useEffect } from 'react';

import {
	type DecisionMakerResponsesItem,
	useDecisionMakerProfilePageData,
} from 'src/app/pages/decisionMakerProfile/pageContext';
import { useDMProfilePagePaginatedResponsesData } from 'src/app/pages/decisionMakerProfile/pageContext';
import { useTrackOnce } from 'src/app/shared/hooks/tracking';

type Result = ModelHookResult<
	{
		displayName: string;
		responses: readonly DecisionMakerResponsesItem[];
		hasNextPage: boolean;
		nextPageLoading: boolean;
	},
	{
		loadMore: () => void;
	}
>;

export function useResponseListRedesign(): Result {
	const {
		data: { displayName },
	} = useDecisionMakerProfilePageData();
	const {
		data: { items, hasNextPage, nextPageLoading },
		actions: { loadMore },
	} = useDMProfilePagePaginatedResponsesData();

	const trackOnce = useTrackOnce();
	useEffect(() => {
		if (items.length > 0) void trackOnce('dm_profile_redesign_response_list_view');
	}, [items.length, trackOnce]);

	return {
		data: {
			displayName,
			responses: items,
			hasNextPage,
			nextPageLoading,
		},
		actions: {
			loadMore,
		},
	};
}
